/* unplugin-vue-components disabled */import { render } from "./PanZoomViewer.vue?vue&type=template&id=068b32f3&scoped=true&ts=true"
import script from "./PanZoomViewer.vue?vue&type=script&lang=ts"
export * from "./PanZoomViewer.vue?vue&type=script&lang=ts"

import "./PanZoomViewer.vue?vue&type=style&index=0&id=068b32f3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068b32f3"]])

export default __exports__